import React, { useEffect, useState } from "react";
import {
  Text,
  View,
  TouchableOpacity,
  SafeAreaView,
  ScrollView,
} from "react-native";
import CustomizeText from "../components/CustomizeText";
import { firebase } from "../../../firebase";
import styles from "../styles/Styles";
import ContactCard from "../components/ContactCard";

const Contact = ({ route }) => {
  const [contacts, setContacts] = useState([]);
  const uid = route.params.member.uid;
  let contactsRef = firebase
    .database()
    .ref("user/" + uid + "/contact/");

  useEffect(() => {
    const handleData = (snap) => {
      if (snap.val()) {
        const json = snap.val();
        const content = Object.values(json);
        setContacts(content);
        
      }
    };
    contactsRef.on("value", handleData, (error) => alert(error));
    return () => {
      contactsRef.off("value", handleData);
    };
  }, []);

  return (
    <View style={{ flex: 1 }}>
      <SafeAreaView style={styles.safeAreaContainer}>
        <ScrollView>
          {contacts.map((contact) => (
            <ContactCard contact={contact} />
          ))}
          <View style={{ height: 20 }} />
        </ScrollView>
      </SafeAreaView>
    </View>
  );
};

export default Contact;
